import React, { Component } from "react";
import MappingResult from './mappingResult';

function App(props) {
    const { data, i18n, themeColor } = props;
    const { report } = i18n;
    const { mappingObj } = report;

    const getResult = value => {
        let params = {}, baseWidth = 150;
        switch(value) {
            case "Low":
                params = {
                    width: baseWidth * 0.2,
                    text: "低等" 
                }
                break;
            case "Low To Medium":
                params = {
                    width: baseWidth * 0.4,
                    text: "低到中等" 
                }
                break;
            case "Medium":
                params = {
                    width: baseWidth * 0.6,
                    text: "中等" 
                }
                break;
            case "Medium To High":
                params = {
                    width: baseWidth * 0.8,
                    text: "中到高等" 
                }
                break;
            case "High":
                params = {
                    width: baseWidth,
                    text: "高等" 
                }
                break;
        }
        return <div className="mapping-box-inner-wrap">
            <div className="mapping-box-inner-rect" style={{width: (params.width + "px")}}></div>
            <div className="mapping-box-inner-text">{i18n.lang == "en_us" ? value : params.text}</div>
        </div>
    }

    return (
        <div className="mapping-wrap">
            <div className="mapping-table">
                <div className="mapping-table-tr">
                    <div className="mapping-table-th">{mappingObj.headerText1}</div>
                    <div className="mapping-table-th">{mappingObj.headerText2}</div>
                    <div className="mapping-table-th">{mappingObj.headerText3}</div>
                </div>
                <div className="mapping-table-tr">
                    <div className="mapping-table-td">
                        <div className="mapping-box bgColor14">
                            <div className="mapping-box-title">{mappingObj.stressReaction}</div>
                            { getResult(data.stress_reaction) }
                        </div>
                    </div>
                    <div className="mapping-table-td">
                        <div className="mapping-tag">{report.nervousness}</div>
                    </div>
                    <div className="mapping-table-td">
                        <div className="mapping-tag">{report.disgust}</div>
                        <div className="mapping-tag">{report.fear}</div>
                        <div className="mapping-tag">{report.contempt}</div>
                        <div className="mapping-tag">{report.angry}</div>
                        <div className="mapping-tag">{report.sadness}</div>
                    </div>
                </div>
                <div className="mapping-table-tr">
                    <div className="mapping-table-td">
                        <div className="mapping-box bgColor15">
                            <div className="mapping-box-title">{mappingObj.outgoing}</div>
                            { getResult(data.outgoing) }
                        </div>
                    </div>
                    <div className="mapping-table-td">
                        <div className="mapping-tag">{mappingObj.extravesion}</div>
                        <div className="mapping-tag">{mappingObj.selfConfidense}</div>
                    </div>
                    <div className="mapping-table-td">
                        <div className="mapping-tag">{report.surprise}</div>
                        <div className="mapping-tag">{report.happines}</div>
                    </div>
                </div>
                <div className="mapping-table-tr">
                    <div className="mapping-table-td">
                        <div className="mapping-box bgColor16">
                            <div className="mapping-box-title">{mappingObj.creativity}</div>
                            { getResult(data.creativity) }
                        </div>
                    </div>
                    <div className="mapping-table-td">
                        <div className="mapping-tag">{mappingObj.innovation}</div>
                        <div className="mapping-tag">{report.curiosity}</div>
                    </div>
                    <div className="mapping-table-td"></div>
                </div>
                <div className="mapping-table-tr">
                    <div className="mapping-table-td">
                        <div className="mapping-box bgColor17">
                            <div className="mapping-box-title">{mappingObj.agreeableness}</div>
                            { getResult(data.agreeableness) }
                        </div>
                    </div>
                    <div className="mapping-table-td">
                        <div className="mapping-tag">{mappingObj.empathy}</div>
                        <div className="mapping-tag">{mappingObj.disagreeing}</div>
                        <div className="mapping-tag">{mappingObj.trust}</div>
                        <div className="mapping-tag">{report.honesty}</div>
                    </div>
                    <div className="mapping-table-td"></div>
                </div>
                <div className="mapping-table-tr">
                    <div className="mapping-table-td">
                        <div className="mapping-box bgColor18">
                            <div className="mapping-box-title">{mappingObj.conscientiousness}</div>
                            { getResult(data.conscientiousness) }
                        </div>
                    </div>
                    <div className="mapping-table-td">
                        <div className="mapping-tag">{report.passion}</div>
                        <div className="mapping-tag">{mappingObj.easyGoing}</div>
                    </div>
                    <div className="mapping-table-td"></div>
                </div>
            </div>
            {/*<div className="mapping-result">
                <div className="mapping-result-title">结果阐述</div>
                <div className="mapping-result-item">
                    <div className="mapping-result-item-title">神经质 — <span style={{ color: themeColor }}>低到中等</span></div>
                    <div className="mapping-result-item-content">
                        神经质或情绪稳定性(Neuroticism)：神经质指个体体验消极情绪的倾向。
                    </div>
                    <div className="mapping-result-item-content">
                        神经质维度得分高的人更容易体验到诸如愤怒、焦虑、抑郁等消极的情绪。他们对外界刺激反应比一般人强烈，对情绪的调节能力比较差，经常处于一种不良的情绪状态下。并且这些人思维、决策、以及有效应对外部压力的能力比较差。
                    </div>
                    <div className="mapping-result-item-content">
                        神经质维度得分低的人较少烦恼，较少情绪化，比较平静，但这并不表明他们经常会有积极的情绪体验，积极情绪体验的频繁程度是外向性的主要内容。
                    </div>
                </div>
                <div className="mapping-result-item">
                    <div className="mapping-result-item-title">外倾性 — <span style={{ color: themeColor }}>低到中等</span></div>
                    <div className="mapping-result-item-content">
                        外倾性(Extraversion)：外倾代表了在外界投入的能量。
                    </div>
                    <div className="mapping-result-item-content">
                        高外倾的人喜欢与人接触，充满活力，经常感受到积极的情绪。他们热情，喜欢运动，喜欢刺激冒险。在一个群体当中，他们非常健谈，自信，喜欢引起别人的注意。
                    </div>
                    <div className="mapping-result-item-content">
                        低外倾的人比较安静，谨慎，不喜欢与外界过多接触。他们不喜欢与人接触不能被解释为害羞或者抑郁，这仅仅是因为比起高外向的人，他们不需要那么多的刺激，因此喜欢一个人独处。低外向人的这种特点有时会被人误认为是傲慢或者不友好，其实一旦和他接触你经常会发现他是一个非常和善的人。
                    </div>
                    <div className="mapping-result-item-content">
                        神经质维度得分高的人更容易体验到诸如愤怒、焦虑、抑郁等消极的情绪。他们对外界刺激反应比一般人强烈，对情绪的调节能力比较差，经常处于一种不良的情绪状态下。并且这些人思维、决策、以及有效应对外部压力的能力比较差。
                    </div>
                    <div className="mapping-result-item-content">
                        神经质维度得分低的人较少烦恼，较少情绪化，比较平静，但这并不表明他们经常会有积极的情绪体验，积极情绪体验的频繁程度是外向性的主要内容。
                    </div>
                </div>
                <div className="mapping-result-item">
                    <div className="mapping-result-item-title">开放性 — <span style={{ color: themeColor }}>低到中等</span></div>
                    <div className="mapping-result-item-content">
                        开放性(Openness)：开放性描述一个人的认知风格。
                    </div>
                    <div className="mapping-result-item-content">
                        开放性得分高的人富有想象力和创造力，好奇，欣赏艺术，对美的事物比较敏感。开放性的人偏爱抽象思维，兴趣广泛。开放性的人适合教授等职业。
                    </div>
                    <div className="mapping-result-item-content">
                        开放性得分低（即封闭性）的人讲求实际，偏爱常规，比较传统和保守。封闭性的人适合警察、销售、服务性职业等。
                    </div>
                </div>
                <div className="mapping-result-item">
                    <div className="mapping-result-item-title">宜人性 — <span style={{ color: themeColor }}>低到中等</span></div>
                    <div className="mapping-result-item-content">
                        宜人性(Agreeableness)代表了“爱”，对合作和人际和谐是否看重。
                    </div>
                    <div className="mapping-result-item-content">
                        宜人性高的人是善解人意的、友好的、慷慨大方的、乐于助人的，愿意为了别人放弃自己的利益。宜人性高的人对人性持乐观的态度，相信人性本善。
                    </div>
                    <div className="mapping-result-item-content">
                        宜人性低的人则把自己的利益放在别人的利益之上。本质上，他们不关心别人的利益，因此也不乐意去帮助别人。有时候，他们对别人是非常多疑的，怀疑别人的动机。对于某些职位来说，太高的宜人性是没有必要的，尤其是需要强硬和客观判断的场合，例如科学家、评论家和士兵。
                    </div>
                </div>
                <div className="mapping-result-item">
                    <div className="mapping-result-item-title">责任心 — <span style={{ color: themeColor }}>低到中等</span></div>
                    <div className="mapping-result-item-content">
                        责任心(Conscientiousness)：责任心指我们控制、管理和调节自身冲动的方式。
                    </div>
                    <div className="mapping-result-item-content">
                        高责任心的人容易避免麻烦，能够获得更大的成功。人们一般认为高责任心的人更加聪明和可靠，但是高责任心的人可能是一个完美主义者或者是一个工作狂。极端责任心的个体让人觉得单调、乏味、缺少生气。
                    </div>
                    <div className="mapping-result-item-content">
                        冲动并不一定就是坏事，有时候环境要求我们能够快速决策。低责任心性的个体常被认为是快乐的、有趣的、很好的玩伴。但是冲动的行为常常会给自己带来麻烦，虽然会给个体带来暂时的满足，但却容易产生长期的不良后果，比如攻击他人，吸食毒品等等。低责任心性的个体一般不会获得很大的成就。
                    </div>
                </div>
            </div>
            <MappingResult />*/}
        </div>
    );
}

export default App;
